import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Link as MuiLink } from '@material-ui/core';

var Link = function Link(_ref) {
  var getBodySlot = _ref.getBodySlot,
      body = _ref.body,
      children = _ref.children,
      color = _ref.color,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      e2e = _ref.e2e,
      href = _ref.href,
      rel = _ref.rel,
      target = _ref.target,
      underline = _ref.underline,
      variant = _ref.variant,
      to = _ref.to;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var hasURL = Boolean(href || to);
  return /*#__PURE__*/React.createElement(MuiLink, _extends({
    color: color,
    component: component
  }, e2e && {
    'data-e2e': e2e
  }, {
    href: href,
    rel: rel,
    target: target,
    underline: underline,
    variant: variant,
    to: to
  }, !hasURL && {
    tabIndex: 0
  }), /*#__PURE__*/React.createElement("span", _extends({
    ref: bodyCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body, children));
};

Link.defaultProps = {
  component: 'a'
};
export default Link;

try {
  Link.__docgenInfo = {
    description: '',
    displayName: 'Link',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      component: {
        defaultValue: {
          value: 'a'
        },
        description: '',
        name: 'component',
        required: false,
        type: {
          name: '"a" | Link<unknown>'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      to: {
        defaultValue: null,
        description: '',
        name: 'to',
        required: false,
        type: {
          name: 'LocationDescriptor<unknown> | ((location: Location<unknown>) => LocationDescriptor<unknown>)'
        }
      },
      color: {
        defaultValue: null,
        description: '',
        name: 'color',
        required: false,
        type: {
          name: 'enum',
          raw: '"error" | "inherit" | "primary" | "secondary" | "textPrimary" | "textSecondary" | "initial"',
          value: [{
            value: '"error"'
          }, {
            value: '"inherit"'
          }, {
            value: '"primary"'
          }, {
            value: '"secondary"'
          }, {
            value: '"textPrimary"'
          }, {
            value: '"textSecondary"'
          }, {
            value: '"initial"'
          }]
        }
      },
      variant: {
        defaultValue: null,
        description: '',
        name: 'variant',
        required: false,
        type: {
          name: 'enum',
          raw: '"inherit" | Variant',
          value: [{
            value: '"inherit"'
          }, {
            value: '"button"'
          }, {
            value: '"caption"'
          }, {
            value: '"h1"'
          }, {
            value: '"h2"'
          }, {
            value: '"h3"'
          }, {
            value: '"h4"'
          }, {
            value: '"h5"'
          }, {
            value: '"h6"'
          }, {
            value: '"subtitle1"'
          }, {
            value: '"subtitle2"'
          }, {
            value: '"body1"'
          }, {
            value: '"body2"'
          }, {
            value: '"overline"'
          }, {
            value: '"srOnly"'
          }]
        }
      },
      href: {
        defaultValue: null,
        description: '',
        name: 'href',
        required: false,
        type: {
          name: 'string'
        }
      },
      rel: {
        defaultValue: null,
        description: '',
        name: 'rel',
        required: false,
        type: {
          name: 'string'
        }
      },
      target: {
        defaultValue: null,
        description: '',
        name: 'target',
        required: false,
        type: {
          name: 'string'
        }
      },
      underline: {
        defaultValue: null,
        description: '',
        name: 'underline',
        required: false,
        type: {
          name: 'enum',
          raw: '"none" | "hover" | "always"',
          value: [{
            value: '"none"'
          }, {
            value: '"hover"'
          }, {
            value: '"always"'
          }]
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map